// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__bJp-V","content":"Page_content__AYoT1","scrollingDisabled":"Page_scrollingDisabled__p7QeF"};